"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GRID_CLICK_IGNORE_CLASS = void 0;
exports.GRID_CLICK_IGNORE_CLASS = "click-outside-ignore";
